import React, { useState } from 'react';
import FileInput from './forked/input/FileInput';
import { Button, makeStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FileField from './forked/field/FileField';
import { ExcelIcon } from '../themes/icons/ExcelIcon';
import DistributionListApi from '../../core/apis/DistributionListApi';
import VirtualizedGrid from '../../core/components/VirtualizedGrid';
import { excelColumns } from '../../features/distributionlists/createsteps/RecipientsLookups';
import { saveAs } from 'file-saver';

import { FormDataConsumer, Loading } from 'react-admin';
import useNotifyServerError from '../hooks/useNotifyServerError';

const useStyles = makeStyles({
  inputField: {
    width: '48%'
  },
  validateButton: {
    marginLeft: '22%',
    marginBottom: '5px'
  },
  templateButton: {
    marginLeft: '4%',
    marginTop: '1.7%'
  },
  templateSpan: {
    color: '#2962FF',
    paddingLeft: '4px',
    fontSize: '15px'
  },
  noRows: {
    color: 'red',
    marginTop: '5px',
    marginBottom: '5px',
    display: 'inline-block',
    float: 'right'
  }
});

const createCellStyle = (rowData, color) => {
  return {
    ...rowData.style,
    color: color,
    fontSize: '14px',
    fontWeight: '400',
    textAlign: 'left',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3px',
    borderTop: '1px solid #E0E0E0',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
};

const StyledFileInput = withStyles({
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const ImportExcelGroup = props => {
  const classes = useStyles();
  const {
    variant,
    setIsNextAvailable,
    setPreselectedUsersEmails,
    setUserIdList
  } = props;
  const notifyServerError = useNotifyServerError();

  const [validateButtonVisibile, setValidateButtonVisibility] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [showNoRowsError, setShowNoRowsError] = useState(false);
  const [loaderVisible, setLoaderVisible] = useState(false);

  var [data, setData] = useState([
    {
      rowIndex: 'Row Number',
      email: 'Email',
      userId: 'User ID',
      validationError: 'Validation Error'
    }
  ]);

  const cleanUpData = value => {
    setData([
      {
        rowIndex: 'Row Number',
        email: 'Email',
        userId: 'User ID',
        validationError: 'Validation Error'
      }
    ]);
    setShowGrid(false);
    setShowNoRowsError(false);
    setIsNextAvailable(false);
    if (value) {
      setValidateButtonVisibility(true);
    } else {
      setValidateButtonVisibility(false);
    }
  };

  const columns = excelColumns.map(col => ({
    id: col.id,
    source: col.id,
    type: 'text',
    renderer: params => {
      const { column, row_data, rowVal } = params;
      const cellStyle = createCellStyle(row_data, col.color);
      return (
        <span style={cellStyle} key={col.id}>
          {rowVal[column.source]}
        </span>
      );
    }
  }));

  const handleClickValidation = async values => {
    const formData = new FormData();
    if (values.file) {
      formData.append('file', values.file.rawFile, values.file.title);
    }
    setValidateButtonVisibility(false);

    setLoaderVisible(true);
    DistributionListApi.validateImportFromExcel(formData)
      .then(responseData => {
        setData(data.concat(responseData));
        var arrayData = data.concat(responseData);
        const validationErrors = arrayData
          .slice(1)
          .filter(r => r.validationError !== null);
        if (responseData.length === 0) {
          setShowNoRowsError(true);
        }
        if (validationErrors.length === 0 && responseData.length > 0) {
          setIsNextAvailable(true);
          const emails = arrayData.slice(1).map(r => r.email);
          const userIds = arrayData.slice(1).map(u => u.userId);
          setPreselectedUsersEmails(emails);
          setUserIdList(userIds);
        }
        setLoaderVisible(false);
        setShowGrid(true);
      })
      .catch(e => {
        setLoaderVisible(false);
        notifyServerError(e);
      });
  };

  const handleDownloadClick = async () => {
    setLoadingDownload(true);
    DistributionListApi.downloadDistributionListImportTemplate()
      .then(resp => {
        const fileName = 'Distribution List Import Template.xlsx';
        saveAs(resp, fileName);
        setLoadingDownload(false);
      })
      .catch(e => {
        setLoadingDownload(false);
        notifyServerError(e);
      });
  };

  return (
    <div>
      <StyledFileInput
        source="file"
        label="Import File"
        accept={
          'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
        placeholder="Drag and drop File Here or Upload"
        resource={props.resource}
        variant={variant}
        onChange={value => cleanUpData(value)}
        className={classes.inputField}
        setIsNextAvailable={props.setIsNextAvailable}
      >
        <FileField source="src" title="title" size="size" type="type" />
      </StyledFileInput>
      <Button
        className={classes.templateButton}
        onClick={loadingDownload ? null : handleDownloadClick}
      >
        <ExcelIcon />
        <span className={classes.templateSpan}>Download Excel Template</span>
      </Button>
      {loaderVisible && <Loading />}
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData &&
          formData.recipientsChoice === 'FILE' &&
          validateButtonVisibile && (
            <div className={classes.validateButton}>
              <Button
                onClick={() => handleClickValidation(formData)}
                color="primary"
                variant="contained"
              >
                Validate
              </Button>
            </div>
          )
        }
      </FormDataConsumer>
      {showGrid && (
        <div>
          <VirtualizedGrid
            columns={columns}
            data={data}
            fixedColumns={0}
            height={'calc(100vh - 350px)'}
            minHeight="400px"
            rowHeight={35}
          />
          {showNoRowsError && (
            <span className={classes.noRows}>
              There are no rows in excel file to be validated. Please, provide
              excel file with data.
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ImportExcelGroup;
